import { Day } from './day'
import { dayOfTheWeek } from './types'

export const ScheduleWeek = () => {
  return (
    <div>
      {dayOfTheWeek.map(({ label: dayName, value: dayValue }) => {
        return <Day key={`week_day_${dayValue}`} dayName={dayName} dayValue={+dayValue} />
      })}
    </div>
  )
}
